import { render, staticRenderFns } from "./ServiceProfileTab.vue?vue&type=template&id=36bec351&scoped=true&"
import script from "./ServiceProfileTab.vue?vue&type=script&lang=js&"
export * from "./ServiceProfileTab.vue?vue&type=script&lang=js&"
import style0 from "./Operations.scss?vue&type=style&index=0&id=36bec351&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bec351",
  null
  
)

export default component.exports